import { Component } from 'react';
import Container from "./Container";
import Toggle from "./controls/Toggle";
import MainLift from './Lifts';
import TrainingMaxPicker from './TrainingMaxPicker';
import Units from "./Units";
import './WeightPicker.css';


class WeightsPicker extends Component {

  unitChanged = (event, newValue) => {
    this.props.unitChanged?.(newValue);
  }

  trainingMaxesChanged = (newMaxes) => {
    this.props.trainingMaxesChanged?.(newMaxes)
  };

  render() {
    const lifts = [
      MainLift.overheadPress,
      MainLift.benchPress,
      MainLift.squat,
      MainLift.deadlift,
    ]

    const unitModes = [
      { label: "lbs", value: Units.Lbs },
      { label: "kg", value: Units.Kg },
    ]

    return <Container title="Weight" className="small">
      <TrainingMaxPicker
        exercises={lifts}
        unit={this.props.unit}
        trainingMaxes={this.props.trainingMaxes}
        trainingMaxesChanged={this.trainingMaxesChanged}
        storageKey="main-lifts"
        plateCalculator={this.props.plateCalculator}>

        <div className="unit-picker">
          Unit <Toggle selected={this.props.unit} onChange={this.unitChanged} arial-label="Weights units" values={unitModes} />
        </div>
      </TrainingMaxPicker>
    </Container>;
  }
}

export default WeightsPicker;